import ValueObject from './ValueObject';

export default class DataSourceMetadataId extends ValueObject {
  equals(other) {
    if (!(other instanceof DataSourceMetadataId)) {
      return false;
    }

    return super.equals(other);
  }

  static fromJSON(json) {
    return new DataSourceMetadataId(json);
  }
}
